import { setToken } from '@mediabank/client';
import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createEpicMiddleware, ofType } from 'redux-observable';
import { Subject } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';

import advancedSearch from './advancedSearch';
import apps from './apps';
import { activeAssets, asset, assetSearchResult } from './assets';
import assetMetaKeys from './assets/metaKeys';
import calendar from './calendar';
import clipLists from './clipLists/clipList';
import clipListDetails from './clipLists/clipListDetails';
import clipListEdit from './clipLists/clipListEdit';
import collections from './collections';
import companyConfig from './companyConfig';
import config from './config';
import contextMenu from './contextMenu';
import demo from './demo';
import displayType from './displayType';
import { eventSearch } from './eventSearch';
import folderEdit from './folders/folderEdit';
import folders from './folders/folders';
import markConfigDialog from './markConfigDialog';
import mBox from './mBox';
import mediaPlayer from './mediaPlayer';
import miniEnv from './miniEnv';
import miniEnvDialog from './miniEnvDialog';
import quickfilter from './quickfilter';
import searchHappenings from './searchHappenings';
import searchProvider from './searchProvider';
import sequence from './sequence';
import events from './tagLists/events';
import happenings from './tagLists/happenings';
import tagLists from './tagLists/tagList';
import tags from './tags';
import ui from './ui';
import user from './user';

const rootReducer = combineReducers({
    activeAssets: activeAssets.reducer,
    advancedSearch: advancedSearch.reducer,
    apps: apps.reducer,
    asset: asset.reducer,
    assetMetaKeys: assetMetaKeys.reducer,
    assetSearchResult: assetSearchResult.reducer,
    calendar: calendar.reducer,
    clipListDetails: clipListDetails.reducer,
    clipListEdit: clipListEdit.reducer,
    clipLists: clipLists.reducer,
    collections: collections.reducer,
    companyConfig: companyConfig.reducer,
    config: config.reducer,
    contextMenu: contextMenu.reducer,
    demo: demo.reducer,
    displayType: displayType.reducer,
    eventSearch: eventSearch.reducer,
    events: events.reducer,
    folderEdit: folderEdit.reducer,
    folders: folders.reducer,
    happenings: happenings.reducer,
    mBox: mBox.reducer,
    markConfigDialog: markConfigDialog.reducer,
    mediaPlayer: mediaPlayer.reducer,
    miniEnv: miniEnv.reducer,
    miniEnvDialog: miniEnvDialog.reducer,
    quickfilter: quickfilter.reducer,
    searchHappenings: searchHappenings.reducer,
    searchProvider: searchProvider.reducer,
    sequence: sequence.reducer,
    tagLists: tagLists.reducer,
    tags: tags.reducer,
    ui: ui.reducer,
    user: user.reducer,
});

const saveAuthToken = () => next => (action = { type: '' }) => {
    if (action.type === 'user/fetchSuccess') {
        setToken(action.payload.token);
    }

    return next(action);
};

const epicMiddleWare = createEpicMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware(), saveAuthToken, epicMiddleWare],
});

store.epic$ = new Subject();
store.injectedEpics = {};

const hotReloadingEpic = (action$, ...rest) =>
    store.epic$.pipe(mergeMap(epic => epic(action$, ...rest).pipe(takeUntil(action$.pipe(ofType('EPIC_END'))))));

epicMiddleWare.run(hotReloadingEpic);

export default store;
